<template>
  <v-app>
    <TitleBar/>

    <v-content>
      <div align="center" class="white">
        <v-card flat max-width="1600" class="ma-0 pa-0">
          <MainBanner/>
          <div class="secondary--text pt-6"><h1>WHAT DO WE PROVIDE?</h1></div>
          <Amenities/>
          <div class="secondary--text pt-4"><h1>HOW DOES IT LOOK?</h1></div>
          <Three60/>
          <div class="secondary--text py-8"><h1>HOW TO REACH US?</h1></div>
          <Map/>
        </v-card>
      </div>
    </v-content>
    <Footer/>
  </v-app>
</template>

<script>
import TitleBar   from './components/TitleBar';
import MainBanner from './components/MainBanner';
import Amenities  from './components/Amenities';
import Three60    from './components/Three60';
import Map        from './components/Map';
import Footer     from './components/Footer';

export default {
  name: 'App',

  components: {
    TitleBar,
    MainBanner,
    Amenities,
    Three60,
    Map,
    Footer,
  },

  data: () => ({
    //
  }),
};
</script>
